const companyActivationActionTypes = {
  FETCH_COMPANY_ACTIVATION_LIST: 'FETCH_COMPANY_ACTIVATION_LIST',
  FETCH_COMPANY_ACTIVATION_LIST_SUCCESS: 'FETCH_COMPANY_ACTIVATION_LIST_SUCCESS',
  FETCH_COMPANY_ACTIVATION_LIST_FAIL: 'FETCH_COMPANY_ACTIVATION_LIST_FAIL',

  FETCH_UPDATE_COMPANY_LICENCE_STATUS: 'FETCH_UPDATE_COMPANY_LICENCE_STATUS',
  FETCH_UPDATE_COMPANY_LICENCE_STATUS_SUCCESS: 'FETCH_UPDATE_COMPANY_LICENCE_STATUS_SUCCESS',
  FETCH_UPDATE_COMPANY_LICENCE_STATUS_FAIL: 'FETCH_UPDATE_COMPANY_LICENCE_STATUS_FAIL',
};

export default companyActivationActionTypes;
